import React, { useEffect, useState } from 'react';
import { FaPlay, FaArrowDown, FaMouse } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  
  const changingTitles = [
    "ההישגים מדברים",
    "תוצאות מוכחות",
    "הצלחה מובטחת",
    "מקצועיות ברמה הגבוהה ביותר"
  ];

  useEffect(() => {
    setIsVisible(true);
    
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };

    // Title changing effect
    const titleInterval = setInterval(() => {
      setCurrentTitleIndex((prevIndex) => 
        (prevIndex + 1) % changingTitles.length
      );
    }, 3000);

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearInterval(titleInterval);
    };
  }, [changingTitles.length]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToNextSection = () => {
    const element = document.getElementById('services-preview');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-bg">
        <div 
          className="hero-gradient"
          style={{
            background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(212, 175, 55, 0.15) 0%, transparent 50%)`
          }}
        ></div>
      </div>

      <div className="container">
        <div className="hero-grid">
          <div className="hero-content">
            <div className={`hero-text ${isVisible ? 'fade-in' : ''}`}>
              <div className="hero-badge">
                <span className="badge-text">Social Media Management</span>
              </div>
              
              <h1 className="hero-title heading-xl">
                <span className="title-line">Media & Marketing</span>
                <span className="title-line title-tagline gradient-text">כל עולם הדיגיטל בכף ידך!</span>
              </h1>
              
              <p className="hero-description text-lg">
                יוצרת חוויות דיגיטליות מרהיבות שמביאות מותגים לחיים. 
                מתמחה בבניית נוכחות ברשתות חברתיות שמעוררת השראה ומניבה תוצאות מדהימות.
              </p>

              <div className="hero-actions">
                <button onClick={scrollToContact} className="btn btn-primary">
                  <span>בואו נתחיל</span>
                </button>
                <button 
                  className="btn btn-secondary"
                  onClick={() => {
                    const element = document.getElementById('projects');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  <FaPlay />
                  <span>צפו בעבודות</span>
                </button>
              </div>

            </div>
          </div>

          <div className="hero-visual">
            <div className="visual-content">
              <div className={`iphone-animation ${isVisible ? 'slide-in-up' : ''}`}>
                <div className="iphone-container">
                  <div className="iphone-frame">
                    <div className="iphone-screen">
                      <div className="screen-content">
                        <div className="phone-body">
                          <div className={`changing-title ${isVisible ? 'fade-in' : ''}`}>
                            <h2 className="title-text">
                              {changingTitles[currentTitleIndex]}
                            </h2>
                          </div>
                          
                          <div className={`achievements-container ${isVisible ? 'slide-in-right' : ''}`}>
                            <div className="achievement-row">
                              <div className="achievement-item">
                                <div className="achievement-number">8+</div>
                                <div className="achievement-text">שנות ניסיון</div>
                              </div>
                              <div className="achievement-item">
                                <div className="achievement-number">50+</div>
                                <div className="achievement-text">לקוחות מרוצים</div>
                              </div>
                            </div>
                            <div className="achievement-row">
                              <div className="achievement-item">
                                <div className="achievement-number">300%</div>
                                <div className="achievement-text">עלייה במכירות</div>
                              </div>
                              <div className="achievement-item">
                                <div className="achievement-number">100+</div>
                                <div className="achievement-text">פרוייקטים מוצלחים</div>
                              </div>
                            </div>
                          </div>
                          
                          <div className={`graph-container ${isVisible ? 'fade-in' : ''}`}>
                            <div className="graph-wrapper">
                              <svg className="graph-svg" viewBox="0 0 100 50" preserveAspectRatio="none">
                                <defs>
                                  <linearGradient id="graphGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stopColor="#4ade80" stopOpacity="0.8"/>
                                    <stop offset="100%" stopColor="#22c55e" stopOpacity="0.3"/>
                                  </linearGradient>
                                  <clipPath id="progressClip">
                                    <rect className="progress-rect" x="0" y="0" width="0" height="50">
                                      <animate
                                        attributeName="width"
                                        from="0"
                                        to="100"
                                        dur="3s"
                                        fill="freeze"
                                      />
                                    </rect>
                                  </clipPath>
                                </defs>
                                <g className="graph-group" clipPath="url(#progressClip)">
                                  <path 
                                    className="graph-fill" 
                                    d="M0,45 L10,42 L20,38 L30,33 L40,30 L50,26 L60,23 L70,18 L80,14 L90,10 L100,8 L100,50 L0,50 Z" 
                                    fill="url(#graphGradient)"
                                  />
                                  <path 
                                    className="graph-line" 
                                    d="M0,45 L10,42 L20,38 L30,33 L40,30 L50,26 L60,23 L70,18 L80,14 L90,10 L100,8" 
                                    fill="none" 
                                    stroke="#22c55e" 
                                    strokeWidth="2.5"
                                  />
                                </g>
                                <circle className="graph-dot" r="2.5" fill="#22c55e">
                                  <animate
                                    attributeName="cx"
                                    values="0;10;20;30;40;50;60;70;80;90;100;100"
                                    dur="3s"
                                    fill="freeze"
                                  />
                                  <animate
                                    attributeName="cy"
                                    values="45;42;38;33;30;26;23;18;14;10;8;8"
                                    dur="3s"
                                    fill="freeze"
                                  />
                                </circle>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="iphone-home-button"></div>
                  </div>
                  <div className="iphone-shadow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="scroll-indicator" onClick={scrollToNextSection}>
        <FaMouse className="scroll-mouse" />
        <div className="scroll-text text-sm">גלו עוד</div>
        <FaArrowDown className="scroll-arrow" />
      </div>
    </section>
  );
};

export default Hero;